import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "src/app/common-components";
import { InfoportalApiComponentsModule } from "../components/infoportal-components.module";
import { InfoportalApiContractDocumentsPageComponent } from "./contract-documents/infoportal-contract-documents-page.component";
import { InfoportalApiReceiptDocumentsPageComponent } from "./receipt-documents/infoportal-receipt-documents-page.component";
import { InfoportalApiReceiptsPageComponent } from "./receipts/infoportal-receipts-page.component";

@NgModule({
  imports: [
    CommonModule,
    CommonComponentsModule,
    InfoportalApiComponentsModule,
  ],
  declarations: [
    InfoportalApiContractDocumentsPageComponent,
    InfoportalApiReceiptDocumentsPageComponent,
    InfoportalApiReceiptsPageComponent,
  ],
  exports: [InfoportalApiReceiptsPageComponent],
})
export class InfoportalApiPagesModule {}
